/* eslint-disable */
import { useState, useEffect } from "react";
import "./index.css";
import { data } from "./data";
import { plans } from "./plans";
import { PickAddOnsList } from "./PickAddOnsList";
import Container from "./components/Container";
import Nav from "./components/Nav";
import Step from "./components/Step";
import Button from "./components/Button";
import Header from "./components/Header";
import PathNote from "./components/PathNote";
import ThankYou from "./pages/ThankYou";
import Summary from "./pages/Summary";
import PickAddOns from "./pages/PickAddOns";
import SelectYourPlan from "./pages/SelectYourPlan";
import PersonalInfoForm from "./pages/PersonalInfoForm";
import EnterOTP from "./pages/EnterOTP";
import BankTransferDetails from "./pages/BankTransferDetails";
import Swal from "sweetalert2";
import Loader from "./components/Loader";

import StepWiseGuide from "./sections/StepWiseGuide";
import Plans from "./sections/Plans";
import Navbar from "./sections/Navbar";
import Footer from "./sections/Footer";
import ReassuranceBlock from "./sections/ReassuranceBlock";
// or via CommonJS

//safepay

import {
  initiateTransaction,
  verifyOTP,
  initiateSafepay,
} from "../src/utils/simpaisaApi";
import Whatsapp from "./sections/Whatsapp";
import { checkSupabaseConnection, supabase } from "./utils/supabase";
import { trackPageViewCapi, trackInitiateCheckout, trackLead } from "./utils/metaPixel";
import { captureAttribution, adSourceString } from "./utils/attribution";
import { getQuizPath } from "./utils/quizPath";

/**
 * Today's date in Pakistan Standard Time, as YYYY-MM-DD.
 *
 * Deliberately not toISOString().slice(0,10) — that is UTC, and PKT is UTC+5,
 * so every event between midnight and 5am local would be stamped with the
 * previous day. These stamps go into Google Ads order ids, where a wrong day
 * boundary means two same-day submissions stop deduplicating against each other.
 */
function pktDateStamp() {
  // en-CA formats as YYYY-MM-DD, which is what we want here.
  return new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Karachi" });
}

/**
 * Opaque per-visit id, used only as a Google Ads order id so a conversion that
 * fires on page load counts once per visit instead of once per page load.
 * sessionStorage on purpose: it dies with the tab, which is exactly the scope
 * of "one visit". Never sent to Meta and unrelated to sjs_xid.
 */
const GOOGLE_VISIT_KEY = "sjs_g_visit";

function googleVisitId() {
  try {
    let id = sessionStorage.getItem(GOOGLE_VISIT_KEY);
    if (!id) {
      id = `bc_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(GOOGLE_VISIT_KEY, id);
    }
    return id;
  } catch {
    // Private mode with storage disabled: fall back to a per-load id. Worst
    // case this behaves the way it always did rather than throwing.
    return `bc_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }
}

// App component
export default function App() {
  return (
    <div className="bg-white">
      <Whatsapp />
      <div className="flex flex-col items-center justify-center bg-white">
        <Navbar />
        {/*
          Removed from above the form: the "Direction Clarity Workshop" bonus
          pill and the money-back-guarantee line. Both were pushing the first
          input a full screen down on mobile. This page's only job is to get the
          form filled — anything above it that isn't the form is a tax.

          The guarantee still appears at step 2, immediately before payment,
          which is where risk reversal actually does work, and it remains
          documented at /refund-policy.
        */}
        <div className="w-full max-w-screen-xl px-4 mt-6 flex flex-col items-center justify-center gap-4">
          {/* Price Notice */}
          <div className="bg-gradient-to-r from-red-50 to-orange-50 border-l-4 border-orange-500 rounded-lg px-4 py-3 max-w-2xl shadow-sm">
            <p className="font-poppins text-xs sm:text-sm text-gray-800 text-center leading-relaxed">
              <span className="font-semibold text-orange-600">⚡ Price Notice:</span> These prices are not guaranteed the next time you visit the site. Complete your enrollment today to lock in your access & start whenever you're ready.
            </p>
          </div>
        </div>
        <StepWiseGuide />
      </div>
      <div className="relative bg-white pt-2 pb-8 md:pt-6 md:pb-12">
        <Form />
      </div>
      <div className="flex flex-col items-center justify-center gap-0">
        <ReassuranceBlock />
        <Footer />
      </div>
    </div>
  );
}

const Form = () => {
  const [timeLeft, setTimeLeft] = useState(30);
  const [step, setStep] = useState(1);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [AddOnsList, setAddOnsList] = useState(PickAddOnsList);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [otpValue, setOTPValue] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const redirectParentWindow = (url) => {
    window.parent.postMessage({ type: "REDIRECT", url }, "*");
    console.log("Redirected User  to Safepay Checkout Page ");
  };

  // useEffect(() => {
  //   if (isLoading) {
  //     Swal.fire({
  //       title: 'Processing ...',
  //       text: 'Please wait',
  //       allowOutsideClick: false,
  //       allowEscapeKey: false,
  //       showConfirmButton: false,
  //       willOpen: () => {
  //         Swal.showLoading();
  //       }
  //     });
  //   } else {
  //     Swal.close();
  //   }
  // }, [isLoading]);

  useEffect(() => {
    checkSupabaseConnection();
    // Remember which ad click brought this visitor (gclid/fbclid/utm from the
    // LP's CTA link) so every lead row below carries its true source.
    captureAttribution();
    // Server-side mirror of the PageView fired in index.html. InitiateCheckout
    // moved to Complete Enrollment (with buyer details) — see trackInitiateCheckout.
    trackPageViewCapi();
    // GA4 begin_checkout at checkout page load (mirrors the pixel
    // InitiateCheckout). Scoped to GA4 only (send_to) so it never reaches the
    // Google Ads tag — Ads conversions are tracked separately by URL. persona
    // (from ?path=) lets GA4 break the funnel down by quiz path.
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "begin_checkout", {
        send_to: "G-EH4NE70PHR",
        value: 6700,
        currency: "PKR",
        path: getQuizPath() || "direct",
      });
      // Google Ads "Begin checkout" conversion, fired as a real event rather
      // than a URL/page-load rule. Value is the Core entry price: the plan
      // isn't chosen until step 2, so 6,700 is the honest estimate here.
      //
      // transaction_id is what stops this from inflating. It had none, so it
      // fired again on every page load — refreshes, back-navigation, a buyer
      // returning later — and each one counted as a fresh conversion. Google
      // Ads drops repeats that share an order id, so one visit now counts once.
      window.gtag("event", "conversion", {
        send_to: "AW-11080800148/OgTaCLmVrNccEJSv3qMp",
        value: 6700,
        currency: "PKR",
        transaction_id: googleVisitId(),
      });
    }
  }, []);

  function getFormattedPhoneNumber(str) {
    // Remove spaces and dashes
    const cleanedStr = str.replace(/[\s-]/g, "");

    // Get the last 10 characters
    if (cleanedStr.length >= 10) {
      return cleanedStr.slice(-10);
    } else {
      // If the cleaned string has less than 10 characters, return the whole string
      return cleanedStr;
    }
  }

  async function handleInitiateTransaction() {
    setTimeLeft(30);
    try {
      setIsLoading(true);
      const data = await initiateTransaction({
        name: name,
        email: email,
        phoneNumber: getFormattedPhoneNumber(phoneNumber),
        walletType: selectedPlan, // or "Jazzcash" for future
      });

      return { success: data.success, message: data.message };
    } catch (error) {
      console.log("Error Initiated", error.message);
      return {
        success: false.success,
        message: error.message || "Something Went Wrong , Please Try Again ! ",
      };
    } finally {
      setIsLoading(false);
    }
  }

  async function handleSafePayInitiateTransaction() {
    try {
      setIsLoading(true);

      console.log("Debug: Sending phoneNumber:", phoneNumber);

      const response = await initiateSafepay({
        name,
        email,
        phoneNumber: getFormattedPhoneNumber(phoneNumber), // 🛠 Ensure formatting
        walletType: selectedPlan, // Card Payments
      });
      console.log("response", response);

      if (response.success) {
        console.log("Redirecting to:", response.url);
        window.location.href = response.url; // Redirect user to Safepay
      } else {
        Swal.fire({
          title: "Payment Failed!",
          text: response.message,
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error initiating Safepay:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong. Please try again.",
        icon: "error",
      });
    } finally {
      setIsLoading(false);
    }
  }

  async function handleVerifyOTP() {
    try {
      const data = await verifyOTP({
        phoneNumber: getFormattedPhoneNumber(phoneNumber),
        otp: otpValue,
        walletType: selectedPlan,
      });
      return { success: data.success, message: data.message };
    } catch (error) {
      return {
        success: false.success,
        message: error.message || "Something Went Wrong , Please Try Again ! ",
      };
    }
  }
  const handleNext = async (e) => {
    // debugger;

    if (step === 1) {
      if (name === "" || email === "" || phoneNumber === "") {
        // Display an error message or perform other actions for failed validation
        Swal.fire({
          title: "Fill Out all fields !",
          text: "Please enter correct information in all fields to continue.",
          icon: "warning",
        });
        return; // Prevent moving to the next step
      }

      if (phoneNumber.length < 10) {
        Swal.fire({
          title: "Invalid Phone Number",
          text: "Please enter correct phone number to continue",
          icon: "warning",
        });
        return; // Prevent moving to the next step
      }

      // Save lead data to database after step 1
      setIsLoading(true);

      // Fire Lead event (browser pixel + CAPI server-side)
      trackLead({ name, email, phone: phoneNumber });
      // InitiateCheckout fires here too — details in hand, so the event pair
      // carries full advanced matching instead of the old anonymous page-load IC.
      trackInitiateCheckout({ name, email, phone: phoneNumber });
      // GA4 generate_lead at form submit (mirrors the pixel Lead). GA4 only.
      if (typeof window !== "undefined" && window.gtag) {
        window.gtag("event", "generate_lead", {
          send_to: "G-EH4NE70PHR",
          value: 6700,
          currency: "PKR",
          path: getQuizPath() || "direct",
        });
        // Google Ads "Submit lead form" conversion. Fires here, at the same
        // point as the Meta Lead — details validated and submitted — so all
        // three systems count a lead at the identical moment.
        //
        // Keyed on the phone so one person submitting twice in a day counts
        // once. Without an order id this counted every re-submit, which is why
        // the Lead action read high against a Purchase action that has always
        // deduplicated properly.
        window.gtag("event", "conversion", {
          send_to: "AW-11080800148/AlGgCKCAsdccEJSv3qMp",
          value: 6700,
          currency: "PKR",
          transaction_id: `lead_${(phoneNumber || "").replace(/\D/g, "") || "anon"}_${pktDateStamp()}`,
        });
      }

      // Store user data in localStorage for step 2
      localStorage.setItem('userName', name);
      localStorage.setItem('userEmail', email);
      localStorage.setItem('phoneNumber', phoneNumber);

      const leadRow = {
        name: name,
        email: email,
        phone_number: phoneNumber,
        plan: "BT - Pending",
        path: getQuizPath(), // quiz persona, or null for main-LP/direct traffic
        ad_source: adSourceString(), // google / meta / organic — first-party attribution
        created_date: new Date().toLocaleString("en-US", {
          timeZone: "Asia/Karachi",
        }),
      };
      let { data, error } = await supabase.from("leads").insert([leadRow]);
      if (error) {
        // If the ad_source column doesn't exist yet, attribution must never
        // block a lead — retry the bare row.
        const { ad_source, ...bareRow } = leadRow;
        ({ data, error } = await supabase.from("leads").insert([bareRow]));
      }
      if (error) {
        console.log("Error Inserting Data", error);
      } else {
        console.log("Data Inserted Successfully", data);
      }
      setIsLoading(false);
    }

    if (step === 2) {
      if (!selectedPlan) {
        // Display an error message or perform other actions for failed validation
        Swal.fire({
          title: "Choose Wallet !",
          text: "Please choose payment method to continue ! ",
          icon: "warning",
        });
        return; // Prevent moving to the next step
      }
      setIsLoading(true);

      const { data, error } = await supabase.from("leads").insert([
        {
          name: name,
          email: email,
          phone_number: phoneNumber,
          plan: selectedPlan,
          path: getQuizPath(), // quiz persona, or null for main-LP/direct traffic
          created_date: new Date().toLocaleString("en-US", {
            timeZone: "Asia/Karachi",
          }),
        },
      ]);
      if (error) {
        console.log("Error Inserting Data", error);
      } else {
        console.log("Data Inserted Successfully", data);
      }

      // alert(selectedPlan)
      if (selectedPlan === "Pakistani / Local Cards") {
        // window.location.href = "https://www.skool.com/sajawal-school/about"
        // window.open('https://www.skool.com/sajawal-school/about', '_blank');
        const response = await handleSafePayInitiateTransaction();
        console.log("Safepay Response", response);
        if (response.status) {
          // window.open(response.url, '_blank');
          window.location.href = response.url;
          // redirectParentWindow(response.url)
        }
        setIsLoading(false);
        return;
      } else if (selectedPlan === "Indian Payments / UPI") {
        window.location.href = "https://learn.sheikhsajawal.co/l/67aa7fba6e";
        setIsLoading(false);
        return;
      } else if (selectedPlan === "International Cards") {
        window.location.href = "https://skool.com/sajawal-school";
        setIsLoading(false);
        return;
      } else {
        console.log("Sending OTP Request ", {
          name,
          email,
          phoneNumber,
          selectedPlan,
        });
        console.log(getFormattedPhoneNumber(phoneNumber));
        const startTransaction = await handleInitiateTransaction();
        console.log("Final Response", startTransaction);
        if (!startTransaction.success) {
          setIsLoading(false);
          Swal.close();
          Swal.fire({
            title: "Error !",
            text: startTransaction.message,
            icon: "error",
          });

          return;
        }
        setOTPValue("");
      }
    }

    if (step === 3) {
      if (otpValue === "" || otpValue.length !== 4) {
        Swal.fire({
          title: "Invalid OTP",
          text: "Please enter a valid OTP received on your mobile number.",
          icon: "error",
        });
        return;
      }

      setIsLoading(true);
      console.log("OTP Entered by User", otpValue);

      let timeoutExceeded = false;

      // Start a timer that will run after 15 seconds if the OTP verification takes too long
      const timer = setTimeout(() => {
        timeoutExceeded = true;
        setIsLoading(false);
        // Swal.fire({
        //   title: 'Timeout',
        //   text: 'The OTP verification is taking too long. Please try again later.',
        //   icon: 'warning',
        // });

        if (step < 5) setStep((s) => s + 1);
      }, 10000);

      try {
        // Call handleVerifyOTP (this function will be executed regardless)
        const confirmOTP = await handleVerifyOTP();

        // Only proceed if the timeout has not exceeded
        if (!timeoutExceeded) {
          clearTimeout(timer); // Clear the timeout if the OTP verification completes on time

          if (!confirmOTP.success) {
            setIsLoading(false);
            Swal.fire({
              title: "Error!",
              text: confirmOTP.message,
              icon: "error",
            });
            setOTPValue("");
            return;
          } else {
            //if user accepts from app within initial set time (10 seconds )
            Swal.fire({
              title: "OTP Confirmed",
              text: "OTP verified successfully!",
              icon: "success",
            });
            setStep(5);
            return;
          }
        } else {
          if (!confirmOTP.success) {
            // alert("We got you finally  ")
            Swal.fire({
              title: "Timeout !",
              text: "Please start over again to continue !",
              icon: "warning",
            });
            setStep(2);
            return;
          } else {
            //if user accepts from app within initial set time (10 seconds )
            Swal.fire({
              title: "OTP Confirmed",
              text: "OTP verified successfully!",
              icon: "success",
            });
            setStep(5);
            return;
          }
        }
      } catch (error) {
        // alert("We got you catch  ")
        if (!timeoutExceeded) {
          clearTimeout(timer);
          setIsLoading(false);
          Swal.fire({
            title: "Error!",
            text: "Something went wrong. Please try again.",
            icon: "error",
          });
        }
      } finally {
        if (!timeoutExceeded) {
          setIsLoading(false);
        }
      }
    }

    e.preventDefault();
    if (step < 5) setStep((s) => s + 1);
    setIsLoading(false);
  };

  function handlePrev(e) {
    e.preventDefault();
    if (step > 1) setStep((s) => s - 1);
  }

  function toggleSelected(name) {
    setAddOnsList((AddOns) =>
      AddOns.map((AddOns) =>
        AddOns.name === name
          ? { ...AddOns, selected: !AddOns.selected }
          : AddOns
      )
    );
  }

  return (
    <div id="react-checkout" className="relative">
      <Container>
        <Loader isLoading={isLoading} />

        <main className="relative h-full w-full">
          {data.map(
            (item) =>
              item.step === step && (
                <Header title={item.title} info={item.info} key={item.step} />
              )
          )}

          {/* Quiz message-match note. Renders only when a ?path= param is
              present, so the main LP funnel sees the checkout unchanged. */}
          <PathNote />

          <div className="relative">
            <div className="main-content ">
              {step === 1 && (
                <PersonalInfoForm
                  step={step}
                  handleNext={handleNext}
                  name={name}
                  setName={setName}
                  email={email}
                  setEmail={setEmail}
                  phoneNumber={phoneNumber}
                  setPhoneNumber={setPhoneNumber}
                  nameError={nameError}
                  setNameError={setNameError}
                  emailError={emailError}
                  setEmailError={setEmailError}
                  phoneNumberError={phoneNumberError}
                  setPhoneNumberError={setPhoneNumberError}
                />
              )}

              {step === 2 && (
                <BankTransferDetails />
              )}

              {/* {step === 3 && (
                <PickAddOns
                  AddOnsList={AddOnsList}
                  setAddOnsList={setAddOnsList}
                  PickAddOnsList={PickAddOnsList}
                  toggleSelected={toggleSelected}
                  isChecked={isChecked}
                />
              )} */}

              {step === 3 && (
                <EnterOTP
                  timeLeft={timeLeft}
                  setTimeLeft={setTimeLeft}
                  handleResend={handleInitiateTransaction}
                  otpValue={otpValue}
                  setOTPValue={setOTPValue}
                />
              )}

              {step === 4 && <Summary />}
              {step === 5 && <ThankYou />}
            </div>

            <div className="w-full flex flex-row items-center justify-center gap-2 sm:gap-4 md:gap-6 px-2 sm:px-4 mt-6 sm:mt-8">
              {step > 1 && step < 5 && step !== 2 && (
                <Button className="btn-secondary" onClick={handlePrev}>
                  <span className="hidden xs:inline">Go Back</span>
                  <span className="xs:hidden">Back</span>
                </Button>
              )}
              {step < 4 && step !== 2 && (
                <Button className="btn-primary" onClick={handleNext}>
                  {step === 1 && (
                    <>
                      👉 Complete Enrollment
                    </>
                  )}
                  {step === 3 && (
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="inline mr-2">
                        <path d="M20 6 9 17l-5-5"/>
                      </svg>
                      Verify OTP
                    </>
                  )}
                </Button>
              )}
              {/* {step === 4 && <Button className='btn-confirm' onClick={handleNext}>Confirm</Button>} */}
            </div>
          </div>
        </main>
      </Container>
    </div>
  );
};
